import List from '@anwb/poncho/components/list';
import Typography from '@anwb/poncho/components/typography';
import { IllustrativeIconsKey } from '@anwb/poncho/utilities/icon-utils';

import { IframeContainer } from './ThankYou.styled';

export const bevestiging = {
	icon: 'mailservice' as IllustrativeIconsKey,
	title: 'Bevestiging',
	description:
		'Je ontvangt van onze partner Ayvens een bevestiging van je aanvraag. Niets ontvangen? Check voor de zekerheid je spambox!',
};

export const reserveringsperiode = {
	icon: 'clock' as IllustrativeIconsKey,
	title: 'Reserveringsperiode',
	description: 'Na de bevestiging heb je 3 werkdagen de tijd om je aanvraag te voltooien.',
};

export const reserveringsperiodeFlex = {
	icon: 'clock' as IllustrativeIconsKey,
	title: 'Reserveringsperiode',
	description: 'Na de bevestiging heb je twee werkdagen de tijd om je aanvraag te voltooien.',
};

export const kredietcheck = {
	icon: 'profile-euro' as IllustrativeIconsKey,
	title: 'Kredietcheck',
	description: (
		<>
			<Typography variant="field-text">
				Voor de kredietcheck heeft Ayvens de volgende gegevens van je nodig:
			</Typography>
			<List variant="numbered">
				<List.Item>
					Een inkomensoverzicht/loonstrook van max. 3 maanden oud incl. je persoons- en
					bankgegevens.
				</List.Item>
				<List.Item>
					Van diezelfde maand een officieel bankafschrift incl. persoons- en bankgegevens.
				</List.Item>
			</List>
			<IframeContainer>
				<iframe
					width="560"
					height="315"
					src="https://www.youtube.com/embed/dwfjBbapqQY"
					title="ANWB Private Lease"
					allowFullScreen
				/>
			</IframeContainer>
		</>
	),
};

export const leasecontractFlex = {
	icon: 'contract-management' as IllustrativeIconsKey,
	title: 'Overeenkomst',
	description: (
		<Typography variant="field-text">
			Je wilt je overeenkomst ondertekenen. Om de snelheid van het proces te bevorderen, kan dit
			allemaal digitaal. Je kunt{' '}
			<Typography
				href="/binaries/content/assets/anwb/pdf/auto/private-lease/voorbeeld-leaseovereenkomst-anwb-private-lease-flex.pdf"
				target="_blank"
				variant="link-text"
				rel="noreferrer"
				data-test="example-contract-link"
			>
				hier
			</Typography>{' '}
			alvast een voorbeeld van een overeenkomst met de voorwaarden inzien.
		</Typography>
	),
};
export const leasecontractOccasion = {
	icon: 'contract-management' as IllustrativeIconsKey,
	title: 'Leasecontract',
	description: (
		<Typography variant="field-text">
			Bij een positief advies kun je het leasecontract ondertekenen. Om de snelheid van het proces
			te bevorderen, kan dit allemaal digitaal. Je kunt{' '}
			<Typography
				href="/binaries/content/assets/anwb/pdf/auto/private-lease/voorbeeld-leaseovereenkomst-anwb-private-lease-occasion.pdf"
				target="_blank"
				variant="link-text"
				rel="noreferrer"
				data-test="example-contract-link"
			>
				hier
			</Typography>{' '}
			alvast een voorbeeld van een overeenkomst met de voorwaarden inzien.
		</Typography>
	),
};

export const leasecontract = {
	icon: 'contract-management' as IllustrativeIconsKey,
	title: 'Leasecontract',
	description: (
		<Typography variant="field-text">
			Bij een positief advies kun je het leasecontract ondertekenen. Om de snelheid van het proces
			te bevorderen, kan dit allemaal digitaal. Je kunt{' '}
			<Typography
				href="/binaries/content/assets/anwb/pdf/auto/private-lease/voorbeeld-leaseovereenkomst-anwb-private-lease.pdf"
				target="_blank"
				variant="link-text"
				rel="noreferrer"
				data-test="example-contract-link"
			>
				hier
			</Typography>{' '}
			alvast een voorbeeld van een leaseovereenkomst met de voorwaarden inzien.
		</Typography>
	),
};

export const ontvangstAuto = {
	icon: 'car-gift' as IllustrativeIconsKey,
	title: 'Ontvangst auto',
	description:
		'Na het tekenen van het contract én het verstrijken van de 14 dagen wettelijke bedenktijd, neemt Ayvens contact met je op voor het maken van een afleverafspraak. Je spreekt de gewenste datum, tijd en locatie af.',
};

export const ontvangstAutoFlex = {
	icon: 'car-gift' as IllustrativeIconsKey,
	title: 'Ontvangst auto',
	description:
		'Na het tekenen van het contract ontvang je mogelijke tijdvakken voor de komende twee werkdagen waarbinnen de auto bij je wordt afgeleverd. ',
};

export const bestellen = {
	icon: 'car-gift' as IllustrativeIconsKey,
	title: 'Bestellen',
	description:
		'Als na het tekenen van het contract de 14 dagen wettelijke bedenktijd verstreken zijn, bestelt Ayvens de auto bij het betreffende merk.',
};

export const inruilen = {
	icon: 'car-sold' as IllustrativeIconsKey,
	title: 'Inruilen',
	description: (
		<Typography variant="field-text">
			Heb je een inruilauto? Dan kun je{' '}
			<Typography
				variant="link-text"
				href="/auto/verkopen/verkoopservice"
				target="_blank"
				rel="noreferrer"
			>
				hier
			</Typography>{' '}
			alvast een bod opvragen. Let op, je huidige auto kan al binnen 1 werkdag verkocht zijn!
		</Typography>
	),
};

export const newLeaseExpectations = [bevestiging, kredietcheck, leasecontract, bestellen, inruilen];
export const occasionLeaseExpectations = [
	bevestiging,
	reserveringsperiode,
	kredietcheck,
	leasecontractOccasion,
	ontvangstAuto,
	inruilen,
];
export const flexLeaseExpectations = [
	bevestiging,
	reserveringsperiodeFlex,
	leasecontractFlex,
	ontvangstAutoFlex,
	inruilen,
];
